export default __webpack_public_path__ + "static/cs-09e6e005a2f12f097c8c200806724d0e.jpeg";